import type { Practitioner, Reference } from '@medplum/fhirtypes'
import type { ExtendedPractitioner } from '@seen/core/models/practitioner'
import { getReferenceString } from '@seen/core/references'
import { useMemo } from 'react'
import { usePractitioners } from '#src/hooks/usePractitioners.ts'

export function usePractitionersFrom(
  refs: Reference<Practitioner>[]
): ExtendedPractitioner[] {
  const practitionerList = usePractitioners()

  return useMemo(() => {
    const relevantPractitionersSet = new Set(refs.map(getReferenceString))

    return practitionerList.filter((p) =>
      relevantPractitionersSet.has(p.reference.reference)
    )
  }, [refs, practitionerList])
}
